'use strict';

exports.__esModule = true;
exports.advancedSearchBarActions = exports.SET_LOCATION_INPUT_FIELD = exports.UPDATE_KEYWORDS_AUTOCOMPLETE = exports.UPDATE_SELECTED_SEARCH_TYPE = exports.UPDATE_SELECTED_TIME_FRAME = exports.RESET_LOCATION = exports.UPDATE_SELECTED_LOCATION = exports.UPDATE_SELECTED_LANGUAGE = exports.UPDATE_SELECTED_INSURER = exports.UPDATE_SELECTED_KEYWORD = exports.UPDATE_SELECTED_VIDEO_CONSULTATION = exports.UPDATE_SELECTED_GENDER = exports.UPDATE_SELECTED_WITHIN = exports.ON_QUERY_STRING_PARSED = exports.UPDATE_LOCATIONS = exports.TOGGLE_CALENDAR = exports.UPDATE_TEXT = undefined;

var _doctifyUtils = require('doctify-utils');

var UPDATE_TEXT = exports.UPDATE_TEXT = 'SEARCH_ACTIONS:UPDATE_TEXT'; // This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var TOGGLE_CALENDAR = exports.TOGGLE_CALENDAR = 'SEARCH_ACTIONS:TOGGLE_CALENDAR';
var UPDATE_LOCATIONS = exports.UPDATE_LOCATIONS = 'SEARCH_ACTIONS:UPDATE_LOCATIONS';
var ON_QUERY_STRING_PARSED = exports.ON_QUERY_STRING_PARSED = 'SEARCH_ACTIONS:ON_QUERY_STRING_PARSED';
var UPDATE_SELECTED_WITHIN = exports.UPDATE_SELECTED_WITHIN = 'SEARCH_ACTIONS:UPDATE_SELECTED_WITHIN';
var UPDATE_SELECTED_GENDER = exports.UPDATE_SELECTED_GENDER = 'SEARCH_ACTIONS:UPDATE_SELECTED_GENDER';
var UPDATE_SELECTED_VIDEO_CONSULTATION = exports.UPDATE_SELECTED_VIDEO_CONSULTATION = 'SEARCH_ACTIONS:UPDATE_SELECTED_VIDEO_CONSULTATION';
var UPDATE_SELECTED_KEYWORD = exports.UPDATE_SELECTED_KEYWORD = 'SEARCH_ACTIONS:UPDATE_SELECTED_KEYWORD';
var UPDATE_SELECTED_INSURER = exports.UPDATE_SELECTED_INSURER = 'SEARCH_ACTIONS:UPDATE_SELECTED_INSURER';
var UPDATE_SELECTED_LANGUAGE = exports.UPDATE_SELECTED_LANGUAGE = 'SEARCH_ACTIONS:UPDATE_SELECTED_LANGUAGE';
var UPDATE_SELECTED_LOCATION = exports.UPDATE_SELECTED_LOCATION = 'SEARCH_ACTIONS:UPDATE_SELECTED_LOCATION';
var RESET_LOCATION = exports.RESET_LOCATION = 'SEARCH_ACTIONS:REMOVE_SELECTED_LOCATION';
var UPDATE_SELECTED_TIME_FRAME = exports.UPDATE_SELECTED_TIME_FRAME = 'SEARCH_ACTIONS:UPDATE_SELECTED_TIME_FRAME';
var UPDATE_SELECTED_SEARCH_TYPE = exports.UPDATE_SELECTED_SEARCH_TYPE = 'SEARCH_ACTIONS:UPDATE_SELECTED_SEARCH_TYPE';
var UPDATE_KEYWORDS_AUTOCOMPLETE = exports.UPDATE_KEYWORDS_AUTOCOMPLETE = 'SEARCH_ACTIONS:UPDATE_KEYWORDS_AUTOCOMPLETE';
var SET_LOCATION_INPUT_FIELD = exports.SET_LOCATION_INPUT_FIELD = 'SEARCH_ACTIONS:SET_LOCATION_INPUT_FIELD';

var advancedSearchBarActions = exports.advancedSearchBarActions = {
	onCalendarFocus: function onCalendarFocus(_ref) {
		var focused = _ref.focused;
		return {
			type: TOGGLE_CALENDAR,
			focused: focused
		};
	},
	onKeywordSelected: function onKeywordSelected(keyword) {
		return {
			type: UPDATE_SELECTED_KEYWORD,
			keyword: keyword
		};
	},
	onInsurerSelected: function onInsurerSelected(insurer) {
		return {
			type: UPDATE_SELECTED_INSURER,
			insurer: insurer
		};
	},
	onLanguageSelected: function onLanguageSelected(language) {
		return {
			type: UPDATE_SELECTED_LANGUAGE,
			language: language
		};
	},
	onWithinSelected: function onWithinSelected(within) {
		return {
			type: UPDATE_SELECTED_WITHIN,
			within: within
		};
	},
	onSortTypeSelected: function onSortTypeSelected(sortType) {
		return {
			type: UPDATE_SELECTED_SEARCH_TYPE,
			sortType: sortType
		};
	},
	onGenderSelected: function onGenderSelected(gender) {
		return {
			type: UPDATE_SELECTED_GENDER,
			gender: gender
		};
	},
	onVideoConsultationSelected: function onVideoConsultationSelected(videoConsultation) {
		return {
			type: UPDATE_SELECTED_VIDEO_CONSULTATION,
			videoConsultation: videoConsultation
		};
	},
	onTimeFrameSelected: function onTimeFrameSelected(dates, timeFrame) {
		return {
			type: UPDATE_SELECTED_TIME_FRAME,
			timeFrame: timeFrame,
			dates: dates
		};
	},
	onLocationSelected: function onLocationSelected(location) {
		return {
			type: UPDATE_SELECTED_LOCATION,
			location: location
		};
	},
	resetLocation: function resetLocation() {
		return {
			type: RESET_LOCATION
		};
	},
	updateLocations: function updateLocations(locations) {
		return {
			type: UPDATE_LOCATIONS,
			locations: locations
		};
	},
	onQueryStringParsed: function onQueryStringParsed(query) {
		return {
			type: ON_QUERY_STRING_PARSED,
			query: query
		};
	},
	updateText: function updateText(text) {
		return {
			type: UPDATE_TEXT,
			text: text
		};
	},
	onKeywordTextChanged: function onKeywordTextChanged(parameters) {
		return (0, _doctifyUtils.createAction)({
			url: 'directory/autocomplete',
			method: 'GET',
			parameters: parameters,
			actionType: UPDATE_KEYWORDS_AUTOCOMPLETE,
			actionData: parameters
		});
	},
	setLocationInputField: function setLocationInputField(inputField) {
		return {
			type: SET_LOCATION_INPUT_FIELD,
			payload: {
				locationInputField: inputField
			}
		};
	}
};


// WEBPACK FOOTER //
// ./components/search-page/lib/actions/advanced-search-bar-actions.js